import { nicheAnime } from '@/mocks/anime';
import AnimeCard from '@/components/base/AnimeCard';
import SectionHeader from '@/components/base/SectionHeader';

export default function NicheSection() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionHeader
        eyebrow="冷门也精彩"
        title="容易被错过的温馨冷门作"
        description="有些宝藏动画评分不低却少有人提，牛奶动漫库替你挖出来，错过真的很可惜。"
        linkText="逛逛日常番合集"
        linkHref="/category/daily"
      />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {nicheAnime.map((anime) => (
          <AnimeCard key={anime.id} anime={anime} />
        ))}
      </div>
    </section>
  );
}